import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
   root: {
      paddingTop: 20,
      paddingLeft: 5,
      paddingRight: 5
   },
   card: {
      padding: 5,
      textAlign: 'center'
   },
   image: {
      paddingTop: 20,
      paddingBottom: 10
   },
   typography: {
      color: theme.palette.primary.contrastText,
      paddingBottom: 5
   }
}))
